import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
} from "reactstrap";
import Select from "react-select";
import axios, { AxiosError } from "axios";
import { LoginFormProp } from "../../../../../Types/Others.type";
import CommonLogo from "./CommonLogo";
import { H2, P } from "../../../../../AbstractElements";
import { useNavigate } from "react-router-dom";
import {
  AddCompany,
  AddDepartment,
  CompanyName,
  CreateYourAccount,
  Department,
  EmailAddress,
  Password,
  RepContact,
  SignIn,
  YourName,
} from "../../../../../Utils/Constants";
import SocialLinks from "./SocialLinks";
import CompanyRegistration from "./CompanyRegistration";
import DepartmentForm from "./DepartmentForm";
import { baseUrl } from "../../../../../Utils/Baseurl/Baseurl";
import "./Registration.css";

import { toast } from "react-toastify";

export default function RegisterForm({ logoClass }: LoginFormProp) {
  const navigate = useNavigate();

  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const togglePassword = () => setPasswordVisible(!isPasswordVisible);
  const [passwordError, setPasswordError] = useState("");
  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const toggleModal = () => setIsModalOpen(!isModalOpen);

  const [isDeptModalOpen, setIsDeptModalOpen] = useState(false);
  // const toggleDeptModal = () => setIsDeptModalOpen(!isDeptModalOpen);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactno: "",
    password: "",
    departmentId: "",
    companyId: "",
    checkbox1: false,
  });
  const validatePassword = (password: string) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
    return passwordRegex.test(password);
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    if (id === "password") {
      if (!validatePassword(value)) {
        setPasswordError(
          "Password must have at least 6 characters, one uppercase letter, one lowercase letter,one number, and one special character."
        );
      } else {
        setPasswordError("");
      }
    }
    if (id === "contactno") {
      if (/^\d*$/.test(value)) {
        setFormData({ ...formData, [id]: value });
      }
    } else {

      setFormData({
        ...formData,
        [id]: value,
      });
    };
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!validatePassword(formData.password)) {
      toast.error(
        "Password must have at least 6 characters, one uppercase letter, one lowercase letter,one number, and one special character."
      );
      return;
    }

    try {
      const payload = {
        name: formData.name,
        contactno: formData.contactno,
        companyId: selectedCompany?.value || null,
        departmentId: selectedDepartment?.value || null,
        email: formData.email,
        password: formData.password,
        usertype: 1, // Assuming medical representative user type is 1
      };

      const response = await axios.post(
        baseUrl + "medicalrep/createmedicalrep",
        payload
      );

      if (response.status === 201) {
        toast.success("Registration Success!");

        // Reset form fields
        setFormData({
          name: "",
          email: "",
          contactno: "",
          password: "",
          companyId: "",
          departmentId: "",
          checkbox1: false,
        });
        setSelectedCompany(null);
        setSelectedDepartment(null);

        // Navigate to login page after a delay
        setTimeout(() => {
          navigate("/login"); // Redirect to login
        }, 3000); // Optional delay to give toast message time to show
      } else {
        toast.error("Error registering medical representative!");
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("Registration Error:", error);
        toast.error(
          error.response?.data?.message ||
          "An error occurred during registration."
        );
      } else {
        console.error("Unexpected Error:", error);
        toast.error("An unknown error occurred!");
      }
    }
  };

  const [companies, setCompanies] = useState<
    { value: number; label: string }[]
  >([]);
  const [selectedCompany, setSelectedCompany] = useState<{
    value: number;
    label: string;
  } | null>(null);

  const fetchCompanies = async () => {
    try {
      const response = await axios.get(
        baseUrl + "companydetails/getAllCompany"
      );
      setCompanies(
        response.data.data.map(
          (company: { id: number; companyname: string }) => ({
            value: company.id,
            label: company.companyname,
          })
        )
      );
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
    fetchCompanies(); // Call fetch function inside useEffect
  }, []);
  useEffect(() => {
    fetchDepartments(); // Fetch all departments on component mount
  }, []);


  const handleCompanyChange = (
    selectedOption: { value: number; label: string } | null
  ) => {
    setSelectedCompany(selectedOption);

  };

  const [departments, setDepartments] = useState<
    { value: number; label: string }[]
  >([]);
  const [selectedDepartment, setSelectedDepartment] = useState<{
    value: number;
    label: string;
  } | null>(null);

  const fetchDepartments = async () => {
    try {
      const response = await axios.get(baseUrl + "department/findAlldepartment");
      console.log(response, 'response');
      setDepartments(
        response.data.data.map((dept: { id: number; departmentname: string }) => ({
          value: dept.id,
          label: dept.departmentname,
        }))
      );
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };


  const handleDepartmentChange = (
    selectedOption: { value: number; label: string } | null
  ) => {
    setSelectedDepartment(selectedOption);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      fetchCompanies(); // Reload companies after modal closes
    }
  };

  const toggleDeptModal = () => {
    setIsDeptModalOpen(!isDeptModalOpen);
    if (!isDeptModalOpen) {
      fetchDepartments(); // Fetch all departments when modal opens
    }
  };



  return (
    <>
      <div className="parent-container" style={{ position: 'relative', top: '-50px' }}>
        {/* Logo (Fixed at the top) */}

        {/* Scrollable Form */}
        <div className="login-scroll-container">
          <div className="login-main">
            <Form className="theme-form" onSubmit={handleSubmit}>
              <div style={{ textAlign: "center" }}>
                <CommonLogo logoClass="logo-class" />
              </div>

              <H2 className="text-center">{CreateYourAccount}</H2>
              <P className="text-center">
                {"Enter your personal details to create an account"}
              </P>

              {/* Company Selection */}
              <FormGroup>
                <Row className="align-items-center">
                  <Col xs="12">
                    <Label>{CompanyName}<span style={{ color: "red" }}>*</span></Label>
                  </Col>

                  <Col xs="9">
                    <Select
                      options={companies}
                      value={selectedCompany}
                      onChange={handleCompanyChange}
                      placeholder="Select a company"
                      isSearchable
                      required
                    />
                  </Col>
                  <Col xs="3" className="text-end">
                    <Button
                      color="primary"
                      className="mt-0"
                      onClick={toggleModal}
                    >
                      {AddCompany}
                    </Button>
                  </Col>
                </Row>
              </FormGroup>

              {/* Department Selection */}
              <FormGroup>
                <Row className="align-items-center">
                  <Col xs="12">
                    <Label>{Department}<span style={{ color: "red" }}>*</span></Label>
                  </Col>
                  <Col xs="9">
                    <Select
                      options={departments} // Now contains all departments
                      value={selectedDepartment}
                      onChange={handleDepartmentChange}
                      placeholder="Select a division"
                      isSearchable
                      required
                    />


                  </Col>
                  {/* <Col xs="3" className="text-end">
                    <Button
                      color="primary"
                      className="mt-0"
                      onClick={toggleDeptModal}
                    >
                      {AddDepartment}
                    </Button>
                  </Col> */}
                </Row>
              </FormGroup>

              {/* Other Fields */}
              <FormGroup>
                <Col>
                  <Label className="pt-0">{YourName}<span style={{ color: "red" }}>*</span></Label>
                </Col>
                <Input
                  type="text"
                  id="name"
                  required
                  placeholder="Full name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </FormGroup>

              <FormGroup>
                <Col>
                  <Label>{RepContact}<span style={{ color: "red" }}>*</span></Label>

                </Col>
                <Input
                  type="tel"
                  id="contactno"
                  required
                  placeholder="1234567890"
                  value={formData.contactno}
                  onChange={handleInputChange}
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
              </FormGroup>

              <FormGroup>
                <Col>
                  <Label>{EmailAddress}<span style={{ color: "red" }}>*</span></Label>
                </Col>
                <Input
                  type="email"
                  id="email"
                  required
                  placeholder="Test@gmail.com"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </FormGroup>

              <FormGroup>
                <Col>
                  <Label>
                    Password<span style={{ color: "red" }}>*</span>
                  </Label>
                </Col>
                <div className="form-input position-relative">
                  <Input
                    type={isPasswordVisible ? "text" : "password"}
                    id="password"
                    required
                    placeholder="*********"
                    value={formData.password}
                    onChange={handleInputChange}
                  />
                  <div className="show-hide" onClick={togglePassword}>
                    <span className={!isPasswordVisible ? "show" : ""}></span>
                  </div>
                </div>
                {passwordError && <p style={{ color: "red" }}>{passwordError}</p>}
              </FormGroup>

              {/* Submit Button */}
              <FormGroup className="mb-0">
                <Button color="primary" className="w-100 mt-3" block>
                  Create Account
                </Button>
              </FormGroup>


              <SocialLinks
                logtext={"Already have an account?"}
                btntext={SignIn}
              />
            </Form>
          </div>
        </div>

        {/* Company Registration Modal */}
        <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
          <ModalHeader toggle={toggleModal}>Register Company</ModalHeader>
          <ModalBody>
            <CompanyRegistration closeModal={toggleModal} />
          </ModalBody>
        </Modal>

        {/* Department Registration Modal */}
        <Modal isOpen={isDeptModalOpen} toggle={toggleDeptModal} centered>
          <ModalHeader toggle={toggleDeptModal}>Register Division</ModalHeader>
          <ModalBody>
            <DepartmentForm closeModal={toggleDeptModal} />
          </ModalBody>
        </Modal>
      </div>
    </>
  );
}
